import { useRef } from "react";
import cx from "classnames";
import { faPrescription, faTag } from "@fortawesome/pro-regular-svg-icons";

import LinkButton from "common/components/LinkButton";
import CatalogImage from "common/components/CatalogImage";
import Icon from "common/components/Icon";

import TextChip from "client/common/components/content/TextChip";
import { urls } from "client/routes";
import { sendSelectItem } from "client/analytics/utils";

import { ProductSearchResult as ProductSearchResultType } from "../types";

import styles from "../styles/ProductSearchResult.module.less";

type ProductSearchResultProps = { result: ProductSearchResultType };

const ProductSearchResult = ({ result }: ProductSearchResultProps) => {
  const resultRef = useRef<HTMLDivElement>(null);

  const hasPrescriptionLabel = Boolean(result.patient_prescription_label);
  const isFeatured =
    result.product_line.is_featured || result.product_line.is_loyalty_program_featured;

  return (
    <LinkButton
      dest={urls.products.detail({
        params: { id: result.product_line.id },
        search: { product: result.id },
      })}
      className={styles.container}
      onClick={() => sendSelectItem(result, "Search Results")}
    >
      <div className={styles.content} ref={resultRef}>
        {result.product_line.prescription_required && (
          <Icon fixedWidth={true} icon={faPrescription} className={styles.prescription} />
        )}
        <div
          className={cx(
            styles.background,
            hasPrescriptionLabel && styles.prescribed,
            !hasPrescriptionLabel && isFeatured && styles.featured,
          )}
        >
          {(hasPrescriptionLabel || isFeatured) &&
            (hasPrescriptionLabel ? (
              <TextChip variant="info" className={styles.chip}>
                {result.patient_prescription_label}
              </TextChip>
            ) : (
              <TextChip variant="highlight" className={styles.chip}>
                Your Vet&apos;s Choice
              </TextChip>
            ))}
          <CatalogImage
            image={result.main_image}
            size="medium"
            alt={result.name}
            className={styles.image}
          />
        </div>
        {result.promotion_label && (
          <div className={styles.promotion}>
            <Icon icon={faTag} /> {result.promotion_label}
          </div>
        )}
      </div>
      <div className={styles.name}>{result.full_name}</div>
    </LinkButton>
  );
};

export default ProductSearchResult;
